// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'mint-ui/lib/style.css'

import axios from 'axios'
Vue.prototype.$http = axios

import filters from './filters'
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

Vue.config.productionTip = false
import './assets/css/css.css'
import './assets/css/response.min.css'

import store from './store'
Vue.prototype.$store = store

Vue.prototype.$getUrlParams = function (value) {
  if (value.indexOf('?') !== -1) {
    let loca = location.href.substring(location.href.indexOf('?') + 1)
    // console.log(loca)
    let str = loca.split('&')
    let object = {}
    str.forEach((val, index) => {
      object[str[index].split('=')[0]] = str[index].split('=')[1]
    })
    return object
  }
}
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js